import './FileRejections.scss'

import React, {useEffect, useState} from 'react'
import {FileError, FileRejection} from 'react-dropzone'
import {useTranslation} from '../../../util/i18n'
import {style} from '../../../util/style'
import {CloseIcon} from './CloseIcon'

const styles = style('filerejections')

export const FileRejections: React.FC<{
	maxSizeMb: number
	fileRejections: Array<
		| FileRejection
		| {file: {name: string; size: number}; errors: Array<FileError>}
	>
}> = ({maxSizeMb, fileRejections}) => {
	useEffect(() => setClosedRejections(new Set()), [fileRejections])

	const [closedRejections, setClosedRejections] = useState(new Set())

	if (!fileRejections.length) return null
	if (fileRejections.length === closedRejections.size) return null

	return (
		<div className={styles()}>
			{fileRejections.map((rejection) => {
				const {file, errors} = rejection
				const key = `${file.name}-${file.size}`

				return (
					!closedRejections.has(key) && (
						<div className={styles('item')} key={key}>
							<p>
								<b>{file.name}</b>
							</p>
							<ul className={styles('item-list')}>
								{errors.length > 0 &&
									errors.map((e: FileError, index: number) => (
										<li
											key={`${e.code}${index}`}
											className={styles('item-list-li')}
										>
											{errorTranslation(e, maxSizeMb)}
										</li>
									))}
							</ul>
							<CloseIcon
								className={styles('item-close')}
								onClick={() => {
									const res = new Set(closedRejections)
									res.add(key)
									setClosedRejections(res)
								}}
							/>
						</div>
					)
				)
			})}
		</div>
	)
}

function errorTranslation(e: FileError, maxSizeMb: number) {
	const t = useTranslation('form').file

	switch (e.code) {
		case 'file-invalid-type':
			return t.invalid_type
		case 'file-too-large':
			return `${t.too_large} ${maxSizeMb}Mb`
		default:
			return e.message
	}
}
